webpackJsonp([46372528695858],{

/***/ 786:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.DefaultPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(786);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(69);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(24);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultPageTemplate = exports.DefaultPageTemplate = function DefaultPageTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      defaultContentSection = _ref.defaultContentSection;
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'DefaultPage' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Assetlogue \u2013 ',
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'default-header' },
	        title && _react2.default.createElement(
	          'h1',
	          null,
	          title
	        ),
	        subtitle && _react2.default.createElement(
	          'p',
	          { className: 'subtitle' },
	          subtitle
	        )
	      ),
	      defaultContentSection && defaultContentSection.map(function (_ref2) {
	        var content = _ref2.content;
	        return _react2.default.createElement(
	          'div',
	          { className: 'default-content' },
	          _react2.default.createElement(_Content2.default, { src: content })
	        );
	      })
	    )
	  );
	};
	
	var DefaultPage = function DefaultPage(_ref3) {
	  var page = _ref3.data.page;
	  return _react2.default.createElement(DefaultPageTemplate, _extends({}, page.frontmatter, { body: page.html }));
	};
	exports.default = DefaultPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-default-page-js-be3230957c87979f03a4.js